import { ComponentType, lazy, LazyExoticComponent } from 'react'

/**
 * Wraps React.lazy with a single retry so a transient network failure while
 * fetching a route chunk doesn't immediately surface a ChunkLoadError. If the
 * chunk is genuinely gone (replaced by a new deployment), the retry fails too
 * and the ErrorBoundary reloads the page to pick up the new build.
 */
export const lazyWithRetry = <P extends object>(
  importComponent: () => Promise<{ default: ComponentType<P> }>
): LazyExoticComponent<ComponentType<P>> =>
  lazy(async () => {
    try {
      return await importComponent()
    } catch {
      return await importComponent()
    }
  })
